import script from "./TgContactWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgContactWindow.vue?vue&type=script&lang=ts&setup=true"

import "./TgContactWindow.vue?vue&type=style&index=0&id=dd1ed490&lang=css"
import "./TgContactWindow.vue?vue&type=style&index=1&id=dd1ed490&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd1ed490"]])

export default __exports__